module.exports = __webpack_public_path__ + "0361872643fdc45cae9cae179bea8f9c.svg";